<template lang="pug">
  div
        .container-fluid
            vm-row(vm-w="12")
                .router
                    router-link(:to="{name: 'inOrders'}")
                        vm-button(icon="arrow-back-outline" radius)
                .headline
                    .title
                        h3 {{ inOrder.project_name }}
                        h3 {{ $t('strings.project_id') }} {{ inOrder.id }}
                        h5 {{ $t('strings.in_order_description') }}
                    .margin
                        router-link(:to="{ name: 'ProjectsGeneralDetail', params: {id: $route.params.id} }")
                            vm-button(icon="grid-outline" title="General View")
                    .margin
                        router-link(:to="{ name: 'rfisProject', params: {id: $route.params.id} }")
                            vm-button(icon="file-text-outline" title="Rfis")
                    .deadline(v-if="inOrder.delivery_deadline")
                        .dl-text Delivery Deadline
                        .dl-date {{ deliveryDate }}
            vm-row(vm-w="12")
                vm-col(vm-lg=2 vm-sm=2)
                    box-menu(v-if="scope_permission" title="Scope" :to="`/in-orders/${this.$route.params.id}/scope`")
                    box-menu(v-if="submittals_permission" title="Submittals" :to="`/in-orders/${this.$route.params.id}/submittals`")
                    box-menu(v-if="change_orders_permission" title="Change Orders" :to="`/in-orders/${this.$route.params.id}/change-orders`")
                    box-menu(v-if="payments_permission" title="Payments" :to="`/in-orders/${this.$route.params.id}/payments`")
                    box-menu(v-if="shipments_permission" title="Shipments" :to="`/in-orders/${this.$route.params.id}/shipments`")
                    box-menu(v-if="gallery_permission" title="Gallery" :to="`/in-orders/${this.$route.params.id}/gallery`")
                    box-menu(v-if="delivery_permission" title="Delivery deadline" :to="`/in-orders/${this.$route.params.id}/delivery-dates`")
                    box-menu(v-if="field_used_drawings_permission" title="Field used drawings" :to="`/in-orders/${this.$route.params.id}/field-used-drawings`")
                vm-col.carta(vm-lg=10 vm-sm=10)
                    router-view
</template>
<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'InOrdersDetail',
  components: {
    BoxMenu: () => import('@/components/aditionals/BoxMenu.vue')
  },
  data: () => ({
    scope_permission: true,
    submittals_permission: true,
    change_orders_permission: true,
    payments_permission: true,
    shipments_permission: true,
    gallery_permission: true,
    delivery_permission: true,
    field_used_drawings_permission: true
  }),
  async created () {
    this.$route.params.id && await this.getInOrder()
    this.checkPermission()
  },
  methods: {
    ...mapActions([
      'loadInOrder'
    ]),
    checkPermission () {
      this.scope_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'scopes.index') > -1
      this.submittals_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'submittals.index') > -1
      this.change_orders_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'change_orders.index') > -1
      this.payments_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'payments.index') > -1
      this.shipments_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'shipments.index') > -1
      this.gallery_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'gallerys.index') > -1
      this.delivery_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'delivery_deadlines.update') > -1
      this.field_used_drawings_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'field_used_drawings.index') > -1
    },
    getTitle () {
      return this.isAdd ? this.$t('in_orders.add') : this.$t('in_orders.edit')
    },
    async getInOrder () {
      this.loadInOrder(this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters([
      'inOrder'
    ]),
    deliveryDate () {
      return moment(this.inOrder.delivery_deadline).format('ll')
    }
  }
}
</script>

<style lang="scss" scoped>
.margin {
    display: flex;
    margin: 0px 8px;
}

.title {
    margin-right: 55%;
}

.router {
    margin: 5px 25px;
}

.headline {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 90%;
    margin: 10px 0px;
}

.carta {
    margin-bottom: 40px;
    background: white;
    padding: 5px;
    border-radius: 5px;
    -webkit-box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
    box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
}

.filters {
    .filter {
        padding: 5px 10px;
        width: 250px;
    }
}

.form {
    padding: 20px 10px 0;
}

.con-vm-tooltip {
    display: inline-block;
    position: relative;
}

.con-vm-tabs {
    padding: 10px;

    .vm-tabs--ul {
        box-shadow: none;
    }

    .vm-tabs--content {
        padding: 0;
    }
}

.vm-col {
    padding: 0 10px;
}

.vm-table--header {
    padding: 0px !important;

    span {
        width: 100%;

        .justify-content-between {
            div:last-child {
                .vm-button {
                    margin: 0 3px;
                    display: block;
                }

                .vm-con-dropdown {
                    float: left;
                }

                .con-select {
                    display: inline-block;

                    input {
                        height: 32px;
                    }
                }
            }
        }
    }
}

@media (min-width:1773px) {
    .headline {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 93%;
        margin: 10px 0px;
    }
}</style>
